<template>
  <section class="g-my-module-style-box">
    <ul class="u-list">
      <li class="u-li" v-for="(item, i) in options" :key="i" :data-active="item.value === value" @click="selectStyle(item.value)">
        <div class="u-img" :style="style(item)"></div>
      </li>
    </ul>
  </section>
</template>

<script>
  export default {
    name: 'my_module_style',
    components: {}, // 注册组件
    directives: {},
    props: {
      value: {
        type: String,
        default: ''
      },
      options: {
        type: Array,
        default: () => []
      }
    },
    data () {
      return {
        formInline: {
        },
        filter: {
        },
        loading: true
      }
    },
    computed: {}, // 计算属性
    watch: {},
    beforeCreate () {},
    created () {},
    mounted () {},
    beforeUpdate () {},
    beforeDestroy () {},
    methods: {
      selectStyle (value) {
        this.$emit('input', value)
      },
      style (item) {
        return {
          background: 'url(' + item.label + ') no-repeat',
          backgroundPosition: item.backgroundPosition
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  .g-my-module-style-box {
    .u-list {
      display: flex;
      padding-left: 15px;
      width: 100%;
      flex-wrap: wrap;
    }
    .u-li {
      position: relative;
      margin-right: 11px;
      margin-top: 11px;
      width: 68px;
      height: 52px;
      border: 1px solid #e7e7eb;
      cursor: pointer;
      &[data-active], &:hover {
        border: 1px solid #5874d8;
      }
      &[data-active]:after {
        position: absolute;
        right: 0;
        bottom: 0;
        content: "";
        width: 28px;
        height: 24px;
        background: url('./../../../static/image/component.png') no-repeat -197px -24px;
      }
    }
    .u-img {
      width: 66px;
      height: 50px;
    }
  }
</style>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/my_module_style/index.vue